import { PHOTOGRAMMETRY_JOB_NAME } from "../../../constants";

/**
 * Determines whether an Orthoimage-RGB pipeline instance produced a point
 * cloud, by inspecting the `--point-cloud` boolean flag in the main step's
 * args of its photogrammetry job.
 *
 * @param {Object} instance - A pipeline instance with
 *   `translatedPipeline.spec.jobs`.
 * @returns {boolean} `true` if the photogrammetry job's main step has the
 *   `--point-cloud` flag activated.
 */
export function hasPointCloud(instance) {
    const jobs = instance.translatedPipeline?.spec?.jobs ?? [];
    const photogrammetryJob = jobs.find(
        (job) => job.name === PHOTOGRAMMETRY_JOB_NAME
    );
    const args = photogrammetryJob?.main?.args ?? [];

    const flagIndex = args.indexOf("--point-cloud");
    if (flagIndex === -1) return false;

    // store_true style: flag present with no value → activated
    const next = args[flagIndex + 1];
    if (next == null || next.startsWith("--")) return true;

    // explicit value (e.g. --point-cloud true / 1)
    return ["true", "1"].includes(next.toLowerCase());
}
